import React from 'react';
import ReactDOM from 'react-dom';
import './setLogs.js';
import { history } from '@src/routes';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from '@src/store';
import { Router } from 'react-router-dom';
import Slidebar from './custom_elements/SlideBar';

import { Kochava } from 'kochava';

//styles imports:
import './scss/base.scss';
import './scss/core.scss';

// define custom elements:
if (!customElements?.get("slide-bar")) {
  customElements?.define("slide-bar", Slidebar);
}

export const KochavaSetup = () => {
  const kochava = Kochava.createForReact();
  // Optional pre-start calls would go here
  kochava.startWithAppGuid("kokoo-koo-tv-kids-j8dptg29");

  return kochava;
};


//get initial configuration:
store.dispatch({ type: 'CONFIG_GET' });

if (process.env.NODE_ENV == 'production') {
  console.log = () => { }
  console.error = () => { }
  console.debug = () => { }
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <App kochava={KochavaSetup()} />
        {/* <App /> */}
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
